import React from "react";
import { Route, Routes } from "react-router";
import AuthOutlet from "@auth-kit/react-router/AuthOutlet";
import AppContainer from "../Components/AppContainer";

import Login from "../pages/user/Login";
import AddSalesPage from "../pages/AddSale/AddSalePage";
import StockList from "../pages/stock/StockList";
import AddStockItem from "../pages/stock/AddStockItem";
import ItemList from "../pages/ItemList";
import CustomerList from "../pages/CustomerList";
import CustomerDetails from "../pages/CustomerDetails";
import SalesList from "../pages/SalesList";
import UsersPage from "../pages/users";
import CustomerSelect from "../pages/AddSale/CustomerSelect";
import AddInvoice from "../pages/AddSale";
import InvoiceViewPage from "../pages/AddSale/InvoiceViewPage";
import Expenses from "../pages/Expenses";
import StockLocationList from "../pages/StockLocations";
import AddBuyInvoice from "../pages/AddBuyInvoice";
import BuyInvoice from "../pages/BuyInvoice";
import BuyInvoices from "../pages/BuyInvoices";
import StockLocationItems from "../pages/StockLocations/items";
import ItemsBelowMinQuantity from "../pages/ItemsBelowMinQuantity";
import CustomerReportsList from "../pages/CustomerReportsList";
import CustomerReport from "../pages/CustomerReport";
import ItemsExpiringSoon from "../pages/ItemsExpiringSoon";
import EditInvoice from "../pages/EditInvoice";
import UnpaidInvoices from "../pages/UnpaidInvoices";
import DailyReport from "../pages/DailyReport";

const wrap = (Page) => (
    <AppContainer>
        <Page />
    </AppContainer>
);

const RoutesComponent = () => (
    <Routes>
        <Route path="/Login" element={<Login />} />
        <Route element={<AuthOutlet fallbackPath="/Login" />}>
            <Route path="/" element={wrap(AddSalesPage)} />
            <Route path="/AddSale" element={wrap(AddSalesPage)} />
            <Route path="/StockList" element={wrap(StockList)} />
            <Route path="/AddStockItem" element={wrap(AddStockItem)} />
            <Route path="/ItemList" element={wrap(ItemList)} />
            <Route path="/CustomerList" element={wrap(CustomerList)} />
            <Route
                path="/CustomerDetails/:id"
                element={wrap(CustomerDetails)}
            />
            <Route path="/SalesList" element={wrap(SalesList)} />
            <Route
                path="/StockLocationList"
                element={wrap(StockLocationList)}
            />
            <Route
                path="/StockLocationItems/:stockLocationId"
                element={wrap(StockLocationItems)}
            />
            <Route path="/AddBuyInvoice" element={wrap(AddBuyInvoice)} />
            <Route path="/BuyInvoices" element={wrap(BuyInvoices)} />
            <Route path="/BuyInvoices/:id" element={wrap(BuyInvoice)} />
            <Route path="/SelectCustomer" element={wrap(CustomerSelect)} />
            <Route path="/AddInvoice" element={wrap(AddInvoice)} />
            <Route path="/Users" element={wrap(UsersPage)} />
            <Route path="/Expenses" element={wrap(Expenses)} />
            <Route path="/unpaid-invoices" element={wrap(UnpaidInvoices)} />
            <Route
                path="/items-below-min-quantity"
                element={wrap(ItemsBelowMinQuantity)}
            />
            <Route
                path="/customer-reports"
                element={wrap(CustomerReportsList)}
            />
            <Route path="/customer-report/:id" element={wrap(CustomerReport)} />
            <Route
                path="/items-expiring-soon"
                element={wrap(ItemsExpiringSoon)}
            />
            <Route path="/EditInvoice/:id" element={wrap(EditInvoice)} />
            <Route path="/daily-report" element={wrap(DailyReport)} />
            <Route path="/Invoice/:id" element={<InvoiceViewPage />} />
        </Route>
    </Routes>
);

export default RoutesComponent;
